import { connect } from "@formily/react";
import { Input as AntInput } from "@formily/antd-v5";

export const Input = connect((props) => {
  const enhancedProps = {
    ...props,
  };

  return <AntInput {...enhancedProps} />;
});
